"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const createWorker_1 = require("./createWorker");
const ImageWorkerImage_1 = require("./ImageWorkerImage");
class ImageWorker {
    constructor() {
        this._items = new Map();
        this._id = 0;
        this._worker = createWorker_1.createWorker();
        this._worker.postMessage({ type: "config", config: { path: window.location.href } });
        this._worker.onmessage = (e) => {
            if (e.data && e.data.id) {
                const id = e.data.id;
                const item = this._items.get(id);
                if (item) {
                    if (e.data.type === "data") {
                        this.finish(item, e.data.info);
                    }
                    else {
                        this.error(item, new Error(`Image loading error type ${e.data.info.type}: ${e.data.info.message}`));
                    }
                }
            }
        };
    }
    destroy() {
        if (this._worker) {
            this._worker.terminate();
        }
    }
    create(src) {
        const id = ++this._id;
        const item = new ImageWorkerImage_1.ImageWorkerImage(this, id, src);
        this._items.set(id, item);
        this._worker.postMessage({ type: "add", id, src });
        return item;
    }
    cancel(image) {
        this._worker.postMessage({ type: "cancel", id: image.id });
        this._items.delete(image.id);
    }
    error(image, info) {
        image.error(info);
        this._items.delete(image.id);
    }
    finish(image, info) {
        image.load(info);
        this._items.delete(image.id);
    }
}
exports.ImageWorker = ImageWorker;
//# sourceMappingURL=ImageWorker.js.map